const DETAIL_NUMBER_POOL_TRAFFIC_SOURCES_HEADERS_TABLE = [
    {
        name: 'Name',
        value: 'name',
        filterSettings: {},
        disabled: true,
        minWidth: 80,
        grow: true,
    },
    {
        name: 'Integration',
        value: 'integration',
        minWidth: 100,
        grow: true,
    },
    {
        name: 'Events',
        value: 'events',
        minWidth: 130,
        filterSettings: {},
        grow: true,
    },
    {
        name: 'Conversions',
        value: 'conversions',
        minWidth: 160,
        withoutPadding: true,
        insertContent: true,
    },
]

const DETAIL_NUMBER_POOL_TRAFFIC_SOURCES_HEADERS_TABLE_WITH_ACTIONS = [
    ...DETAIL_NUMBER_POOL_TRAFFIC_SOURCES_HEADERS_TABLE,
    {
        name: 'Actions',
        value: 'actions',
        minWidth: 80,
        align: 'center',
        disabled: true,
    },
]

export {
    DETAIL_NUMBER_POOL_TRAFFIC_SOURCES_HEADERS_TABLE,
    DETAIL_NUMBER_POOL_TRAFFIC_SOURCES_HEADERS_TABLE_WITH_ACTIONS,
}
